import React  from 'react';
import { List, Segment, Header} from 'semantic-ui-react';
import { Link } from "react-router-dom";
 
import '../../App.css';
 


const Objetivo=({ id, margenes, titulo, objetivos=[], color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, curso})=>{
    
 

	return (
        <Segment basic style={margenes}>
        <Header as='h2' dividing>
            {strings?strings[titulo]:""}
        </Header>
          
             <List divided relaxed>
        {curso.aprendizaje.map(row =>
            <List.Item>
              <List.Icon name='check' color="orange" size='large' verticalAlign='middle' />
              <List.Content>
                <List.Header as='a'>{row.texto}</List.Header>
              </List.Content>
            </List.Item>
         )}	
             
          </List>


     
        </Segment>
	);
};



export default Objetivo;